<script>
    import { createEventDispatcher } from 'svelte';

    export let currentFilter = 'all'; // Filter state passed from parent
    export let beforeChange = null;

    const dispatch = createEventDispatcher(); // Create the event dispatcher

    const setFilter = async (filter) => {
        if (beforeChange && !await beforeChange(filter)) return;
        currentFilter = filter; // Update the filter
        dispatch('filterChange', { filter }); // Dispatch the 'filterChange' event
    };
</script>

<div class="filter-buttons">
    <button 
        class:active={currentFilter === 'all'} 
        on:click={() => setFilter('all')}>
        Visos
    </button>
    
    <button 
        class:active={currentFilter === 'upcoming'} 
        on:click={() => setFilter('upcoming')}>
        Būsimos
    </button>
    <button 
        class:active={currentFilter === 'past_classes'} 
        on:click={() => setFilter('past_classes')}>
        Buvusios
    </button>

</div>

<style>
    .filter-buttons {
        display: flex;
        gap: 1rem;
        height: 60px;
        justify-content: space-between;
    }

    button { 
        border-radius: 8px;
        background-color: white;
        color: #000000;
        font-size: 1rem;
        font-weight: bold;
        cursor: pointer;
        transition: background-color 0.3s, color 0.3s;
        width:100%;
    }

    button.active {
        background-color: #14695b;
        color: white;
    }

    button:hover {
        background-color: #14695b;
        color: white;
    }
</style>
